export const InitializationStepId = 'initialization';

export type InitializationStep = {
  id: typeof InitializationStepId;
  Component: () => null;
};

export enum WizardStepId {
  Landing = 'landing',
  Terms = 'terms',
  PersonalInfo = 'personal-info',
  ReviewPersonalInfo = 'review-personal-info',
  KiqOnboarding = 'kiq-onboarding',
  KiqQuestions = 'kiq-questions',
}

export enum WizardStepTitle {
  Landing = 'Landing',
  Terms = 'Terms',
  PersonalInfo = 'Personal Info',
  ReviewPersonalInfo = 'Review Personal Info',
  KiqOnboarding = 'Kiq Onboarding',
  KiqQuestions = 'Kiq Questions',
}

export type WizardStep = {
  id: WizardStepId;
  title: WizardStepTitle;
  Component: React.ComponentType;
  nextButtonText?: string;
  renderBackButton?: boolean;
};

export enum ErrorWizardStepId {
  Generic = 'generic',
  UserNotFound = 'user-not-found',
  UserNotFoundLockedOut = 'user-not-found-locked-out',
  UserLockedOut = 'user-locked-out',
  IncorrectAnswers = 'incorrect-answers',
  FrozenAccount = 'frozen-account',
  FrozenAccountWarning = 'frozen-account-warning',
  ForbiddenIp = 'forbidden-ip',
}

export enum ErrorWizardStepTitle {
  Generic = 'Generic',
  UserNotFound = 'UserNotFound',
  UserNotFoundLockedOut = 'User Not Found Locked Out',
  UserLockedOut = 'UserLockedOut',
  IncorrectAnswers = 'Incorrect Answers',
  FrozenAccount = 'Frozen Account',
  FrozenAccountWarning = 'Frozen Account Warning',
  ForbiddenIp = 'Forbidden Ip',
}

export type ErrorWizardStep = {
  id: ErrorWizardStepId;
  title: ErrorWizardStepTitle;
  Component: React.ComponentType;
  nextButtonText?: string;
};

export type WizardState = {
  currentStep: InitializationStep | WizardStep | ErrorWizardStep;
  activeSteps: Array<InitializationStep | WizardStep | ErrorWizardStep>;
};

export enum WizardActionType {
  GOTO_STEP = 'GOTO_STEP',
  GOTO_ERROR_STEP = 'GOTO_ERROR_STEP',
  GOTO_NEXT_STEP = 'GOTO_NEXT_STEP',
  GOTO_PREVIOUS_STEP = 'GOTO_PREVIOUS_STEP',
}

export type WizardAction =
  | { type: WizardActionType.GOTO_STEP; stepId: WizardStepId }
  | { type: WizardActionType.GOTO_ERROR_STEP; stepId: ErrorWizardStepId }
  | { type: WizardActionType.GOTO_NEXT_STEP; activeSteps: Array<WizardStep> }
  | { type: WizardActionType.GOTO_PREVIOUS_STEP; activeSteps: Array<WizardStep> };

export interface WizardContextValue {
  dispatch: React.Dispatch<WizardAction>;
  currentStep: InitializationStep | WizardStep | ErrorWizardStep;
  currentIndex: number; // Can be number or error step ID for error cases
  goToStep: (stepId: WizardStepId) => void;
  goToErrorStep: (stepId: ErrorWizardStepId) => void;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  onNext: (() => void | Promise<void>) | null;
  setOnNext: React.Dispatch<React.SetStateAction<(() => void | Promise<void>) | null>>;
  isNextDisabled: boolean;
  setIsNextDisabled: (disabled: boolean) => void;
  isBackDisabled: boolean;
  setIsBackDisabled: (disabled: boolean) => void;
  activeSteps: Array<WizardStep>;
  setActiveSteps: (steps: Array<WizardStep>) => void;
}
